<template>
  <b-modal id="mass-idp-status-export-modal" :modal-class="`adp-modal`" :body-class="`adp-modal-body`"
           :header-class="`adp-modal-header`" :footer-class="`adp-modal-footer d-flex justify-content-center`"
           @show="onShow">
    <template #modal-title>
      <div class="d-flex">
        <span class="modal-title adp-h2 adp-h2__modal">{{ $t('modal.idp_status_export') }}</span>
      </div>
    </template>
    <template #modal-header-close>
      <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
    </template>
    <template>
      <div class="adp-modal-row mb-3">
        <label class="adp-p adp-p__grey">{{ $t('modal.idp_export_year') }}</label>
        <my-dropdown :options="IDPYears" :init-selected="selectedYears" :has-select-all="true" :for-modal="true"
                     v-on:my-change="changeYear($event, 'selectedYears')" :localize="false">
        </my-dropdown>
      </div>
    </template>
    <template #modal-footer>
      <button id="save" class="btn btn-primary adp-btn adp-btn__large" style="margin-left: auto"
              @click="download()" :disabled="selectedYears.length === 0">
        {{ $t('modal.idp_export_download') }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import api from "../../../api";
import MyDropdown from "../../MyDropdown";

export default {
  name: "MassIdpStatusExportModal",
  props: {
    pernumbers: {
      type: Array,
      required: true,
    }
  },
  components: {MyDropdown},
  data: function () {
    return {

      selectedYears: [],
    }
  },
  computed: {
    IDPYears() {
      const currentYear = new Date().getFullYear();
      let year = 2021;
      let years = [year];

      while (year !== currentYear) {
        year++;
        years.push(year);
      }

      return [...years, currentYear+1, currentYear+2, currentYear+3].map(x => ({code: x, id: x}));
    },
  },
  methods: {
    onShow() {
      this.selectedYears = [new Date().getFullYear()];
    },
    changeYear(e, property) {
      this[property] = e;
    },
    async download() {
      const data = {
        'pernumbers': this.pernumbers,
        'selectedYears': this.selectedYears,
      };

      await api.exportIdpStatus(data)
        .then(() => this.$bvModal.hide('mass-idp-status-export-modal'))
        .then(() => {
          let reportsIcon = document.getElementById('reports-download')
          let loadingIcon = document.getElementById('reports-download-circle')
          reportsIcon.hidden = true
          loadingIcon.hidden = false
        });
    }
  }
}
</script>
